import { Flex } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import ButtonOutline from 'UiKit/button/buttonOutline';
import { getMenuPermissions } from 'Helper/getMenuPermissions';
import { EditIcon, TrashIcon } from 'Asset/icon';

import useOpenDeleteModal from 'View/target/hooks/useOpenDeleteModal';
import { useTargetState } from 'View/target/state';

const ActionButton = ({ values }) => {
  const accessPermission = getMenuPermissions('achievement', 'target');
  const { onOpenDeleteModal } = useOpenDeleteModal();
  const { updateState } = useTargetState();

  return (
    <Flex gap="10px">
      <Condition statement={accessPermission?.isCanEdit}>
        <ButtonOutline
          borderWidth="1.5px"
          minWidth="34px"
          width="34px"
          height="34px"
          onClick={() => {
            updateState({
              isOpenFormUpsert: true,
              isEditFormUpsert: true,
              selectedTarget: values,
            });
          }}
          data-testid="edit-button-target-list"
        >
          <EditIcon color="var(--color-info70)" size="18px" />
        </ButtonOutline>
      </Condition>

      <Condition statement={accessPermission?.isCanDelete}>
        <ButtonOutline
          borderWidth="1.5px"
          color="var(--color-error50)"
          minWidth="34px"
          width="34px"
          height="34px"
          onClick={() => onOpenDeleteModal(values.id)}
          data-testid="delete-button-target-list"
        >
          <TrashIcon color="var(--color-error50)" size="18px" />
        </ButtonOutline>
      </Condition>
    </Flex>
  );
};

export default ActionButton;
